import { Avatar, Box, EnhancedDimension } from '@factorialco/deprecated-design-system'

import { UnionSoftwareType } from 'modules/software_management/lib/software'

import './index.styles.css'
interface Props {
  software: UnionSoftwareType
  size?: EnhancedDimension
}
const SoftwareLogo = ({ software, size }: Props) => {
  return (
    <Box className={'_SoftwareLogo_softwareLogo'} width="fit-content">
      <Avatar size={size} label={software.name} url={software.logoUrl} />
    </Box>
  )
}

export default SoftwareLogo
